<div class="checkout-summary-headline" *ngIf="activeStep!==4 || !isMobile">
    {{'common.checkout_multi_order_summary'|cxTranslate}}</div>
<ng-container *ngIf="!isMobile">
    <div class=" order-conformation-summary-list">
        <div class="checkout-order-summary">
            <ul class="checkout-order-summary-list" *ngIf="orderSummary">
                <div class="mainEntryGroup" *ngFor="let entry of orderSummary">
                    <!-- sales bomb start -->
                    <ng-container *ngIf="entry.associatedEntries && entry.posType=='KH'">
                        <mat-expansion-panel hideToggle>
                            <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'190px'">
                                <mat-panel-title>
                                    <li class="checkout-order-summary-list-items  ">
                                        <div class="thumb product-list-item-img order-summary-img">
                                            <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                                <cx-media
                                                    [container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
                                            </a>
                                        </div>
                                        <div class="checkout-EntryNumber">
                                            {{entry?.updatedEntryNumber}}
                                        </div>
                                        <div class="details">
                                            <div class="checkout-Entryitem-block  d-flex">
                                                <div class="col-xs-12 col-sm-5 col-md-6">
                                                    <div>
                                                        <a
                                                            [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                                            <strong class="name">{{entry?.product?.code}}</strong>
                                                        </a>
                                                        <span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
                                                            {{entry?.product?.typenumber}}
                                                        </span>
                                                    </div>

                                                    <div class="f-14">
                                                        <br>
                                                        {{entry?.product?.name}}
                                                        <br>
                                                    </div>
                                                    <div class="f-14" *ngIf="entry?.customPartNumber">
                                                        {{'common.text_cust_part_no'|cxTranslate}}:
                                                        {{entry?.customPartNumber}}
                                                    </div>
                                                    <div class="checkout-Entryitem-qty">
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-7 col-md-6
                                               d-flex flex-column
                                                  order-confirmation-price-block">
                                                    <div *ngIf="fleetPrideGroup">
                                                        <span class="checkout-listprice-block f-14 "
                                                            *ngIf="showListPrice$|async">
                                                            <span class="checkout-label-priceLabel ">
                                                                {{'common.basket_page_listprice'|cxTranslate}}:
                                                            </span>
                                                            <span class="checkout-input-price float-right">
                                                                <strong
                                                                    *ngIf="!entry?.listPrice || entry?.listPrice.indexOf('-') > -1 ; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
                                                                <ng-template
                                                                    #listPrice><strong>{{entry?.listPrice}}&nbsp;{{entry?.listPrice?.currencyIso}}</strong></ng-template>
                                                            </span>
                                                        </span>
                                                        <span class="checkout-netprice-block f-14"
                                                            *ngIf="showNetPrice$|async">
                                                            <span class="checkout-label-priceLabel ">
                                                                {{'common.basket_page_netprice'|cxTranslate}}:
                                                            </span>
                                                            <span class="checkout-input-price float-right">
                                                                <strong
                                                                    *ngIf="!entry?.basePrice.formattedValue || entry?.basePrice.formattedValue.indexOf('-') > -1; else netPrice">
                                                                    {{'common.basket_page_poa'|cxTranslate}}
                                                                </strong>
                                                                <ng-template #netPrice>
                                                                    <strong>
                                                                        {{entry?.basePrice.formattedValue}}&nbsp;{{entry?.basePrice.currencyIso}}
                                                                    </strong>
                                                                </ng-template>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="checkout-required-block d-flex align-items-center f-14">
                                                <div class="del-quantity f-14">
                                                    {{'common.basket_page_emea_orderQty'|cxTranslate}}:<span>
                                                        {{entry?.formattedQuantity}}</span>
                                                </div>
                                                <div class="checkout-requiredDeliveryDate ">
                                                    <span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
                                                        : </span><span class="f-13">{{entry?.requestedDeliveryDate |
                                                        kbDateFormat}}</span>
                                                </div>
                                                <div class="checkout-estimateDeliveryDate "
                                                    *ngIf="(activeStep == 4) && (entry?.updateable)">
                                                    <span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}}
                                                        :</span>
                                                    <span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
                                                        class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                                    </span>
                                                    <span class="f-14" *ngIf="entry.estimatedDeliveryDate"
                                                        class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
                                                    </span>


                                                </div>
                                                <ng-template #closeit></ng-template>
                                            </div>
                                        </div>
                                    </li>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <li class="checkout-order-summary-list-items" *ngFor="let item of entry.associatedEntries">

                                <div class="thumb product-list-item-img">
                                    <a [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl">
                                        <cx-media
                                            [container]="item?.product?.images && item?.product?.images['PRIMARY'] || item?.product?.images"></cx-media>
                                    </a>
                                </div>
                                <div class="checkout-EntryNumber">
                                    {{item?.updatedEntryNumber}}
                                </div>
                                <div class="details">
                                    <div class="checkout-Entryitem-block  d-flex">
                                        <div class="col-xs-12 col-sm-5 col-md-6">
                                            <div>
                                                <a [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl">
                                                    <strong class="name">{{item?.product?.code}}</strong>
                                                </a>
                                            </div>
                                            <div class="f-14">
                                                <br>
                                                {{item?.product?.name}}
                                                <br>
                                            </div>
                                            <div class="f-14" *ngIf="entry?.customPartNumber">
                                                {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                            </div>
                                            <div class="checkout-Entryitem-qty">
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-7 col-md-6
                                           d-flex flex-column
                                              order-confirmation-price-block">

                                            <div *ngIf="fleetPrideGroup">
                                                <span class="checkout-netprice-block f-14" *ngIf="showCorePrice$|async">
                                                    <span
                                                        class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
                                                    <span class="checkout-input-price float-right">
                                                        <strong
                                                            *ngIf="!item?.surcharge?.formattedValue || item?.surcharge?.formattedValue.indexOf('-') > -1; else corePrice">
                                                            {{'common.basket_page_poa'|cxTranslate}}
                                                        </strong>
                                                        <ng-template #corePrice>
                                                            <strong>
                                                                {{item?.surcharge?.formattedValue}}&nbsp;{{item?.surcharge?.currencyIso}}
                                                            </strong>
                                                        </ng-template>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="checkout-required-block d-flex align-items-center f-14 sales-bomb-body">
                                        <div class="del-quantity f-14">
                                            {{'common.text_checkout_page_delivery_qty'|cxTranslate}}<span>
                                                {{item?.formattedQuantity}}</span>
                                        </div>

                                        <ng-template #closeit></ng-template>
                                    </div>
                                </div>
                            </li>
                        </mat-expansion-panel>
                    </ng-container>
                    <!-- sales bomb end -->

                    <!-- Replaced By Start -->
                    <ng-container *ngIf="entry.associatedEntries && entry.posType=='AH'">
                        <li class="checkout-order-summary-list-items replace-by-list">
                            <div class="replaced-by-top">
                                <div class="thumb product-list-item-img">
                                    <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                        <cx-media
                                            [container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
                                    </a>
                                </div>
                                <div class="checkout-EntryNumber">
                                    {{entry?.updatedEntryNumber}}
                                </div>
                                <div class="details">
                                    <div class="checkout-Entryitem-block  d-flex">
                                        <div class="col-xs-12 col-sm-5 col-md-6">
                                            <div>
                                                <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                                    <strong class="name">{{entry?.product?.code}}</strong>
                                                </a>
                                                <span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
                                                    {{entry?.product?.typenumber}}
                                                </span>
                                            </div>
                                            <div class="f-14 product-name">
                                                <p>{{entry?.product?.name}}</p>
                                            </div>
                                            <div class="f-14" *ngIf="entry?.customPartNumber">
                                                {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                            </div>
                                        </div>

                                    </div>
                                    <div class="checkout-required-block d-flex align-items-center f-14">
                                        <div class="del-quantity f-14">
                                            {{'common.text_checkout_page_delivery_qty'|cxTranslate}}<span>
                                                {{entry?.formattedQuantity}}</span>
                                        </div>
                                        <ng-template #closeit></ng-template>
                                    </div>
                                    <div class="replaced-by-text">
                                        {{'common.checkout_page_replaced'|cxTranslate}}
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngFor="let item of entry.associatedEntries">
                                <div class="thumb product-list-item-img">
                                    <a [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl">
                                        <cx-media
                                            [container]="item?.product?.images && (item?.product?.images['PRIMARY'] || item?.product?.images)"></cx-media>
                                    </a>
                                </div>
                                <div class="checkout-EntryNumber">
                                    {{item?.updatedEntryNumber}}
                                </div>
                                <div class="checkout-Entryitem-block d-flex replaced-by-entries">
                                    <div class="col-xs-12 col-sm-5 col-md-6">
                                        <div>
                                            <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                                <strong class="name">{{item?.product?.code}}</strong>
                                            </a>
                                        </div>
                                        <div class="f-14">
                                            <br>
                                            {{item?.product?.name}}
                                            <br>
                                        </div>
                                        <div class="f-14" *ngIf="entry?.customPartNumber">
                                            {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                        </div>
                                        <div class="checkout-Entryitem-qty">
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-7 col-md-6
                               d-flex flex-column
                                  order-confirmation-price-block">
                                        <div *ngIf="fleetPrideGroup">
                                            <span class="checkout-listprice-block f-14 " *ngIf="showListPrice$|async">
                                                <span class="checkout-label-priceLabel ">
                                                    {{'common.basket_page_listprice'|cxTranslate}}:
                                                </span>
                                                <span class="checkout-input-price float-right">
                                                    <strong
                                                        *ngIf="!item?.listPrice?.formattedValue || item?.listPrice?.formattedValue.indexOf('-') > -1; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
                                                    <ng-template
                                                        #listPrice><strong>{{item?.listPrice?.formattedValue}}&nbsp;{{item?.listPrice?.currencyIso}}</strong></ng-template>
                                                </span>
                                            </span>
                                            <span class="checkout-netprice-block f-14" *ngIf="showNetPrice$|async">
                                                <span class="checkout-label-priceLabel ">
                                                    {{'common.basket_page_netprice'|cxTranslate}}:
                                                </span>
                                                <span class="checkout-input-price float-right">
                                                    <strong
                                                        *ngIf="!item?.basePrice?.formattedValue || item?.basePrice?.formattedValue.indexOf('-') > -1 ; else netPrice">
                                                        {{'common.basket_page_poa'|cxTranslate}}
                                                    </strong>
                                                    <ng-template #netPrice>
                                                        <strong>
                                                            {{item?.basePrice?.formattedValue}}&nbsp;{{item?.basePrice?.currencyIso}}
                                                        </strong>
                                                    </ng-template>
                                                </span>
                                            </span>
                                            <span class="checkout-netprice-block f-14 " *ngIf="showCorePrice$|async">
                                                <span
                                                    class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}&nbsp;&nbsp;</span>
                                                <span class="checkout-input-price float-right">
                                                    <strong
                                                        *ngIf="!item?.surcharge?.formattedValue || item?.surcharge?.formattedValue.indexOf('-') > -1; else corePrice">
                                                        {{'common.basket_page_poa'|cxTranslate}}
                                                    </strong>
                                                    <ng-template #corePrice>
                                                        <strong>
                                                            {{item?.surcharge?.formattedValue}}&nbsp;{{item?.surcharge?.currencyIso}}
                                                        </strong>
                                                    </ng-template>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="checkout-required-block d-flex align-items-center f-14 replaced-by-bottom">
                                    <div class="del-quantity f-14">
                                        {{'common.basket_page_emea_orderQty'|cxTranslate}}:<span>
                                            {{item?.estimatedQuantity}}</span>
                                    </div>
                                    <div class="checkout-requiredDeliveryDate ">
                                        <span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
                                            : </span><span
                                            class="f-13">{{item?.requestedDeliveryDate|kbDateFormat}}</span>
                                    </div>
                                    <div class="checkout-estimateDeliveryDate "
                                        *ngIf="(activeStep == 4) && (item?.updateable)">
                                        <span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
                                        <span class="f-14" *ngIf="!item.estimatedDeliveryDate"
                                            class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                        </span>
                                        <span class="f-14" *ngIf="item.estimatedDeliveryDate"
                                            class="checkout-estimate-empty">{{item?.estimatedDeliveryDate}}
                                        </span>

                                    </div>
                                    <ng-template #closeit></ng-template>
                                </div>
                            </ng-container>
                        </li>
                    </ng-container>
                    <!-- Replaced By end -->

                    <!-- Split Start -->
                    <ng-container *ngIf="entry.associatedEntries && entry.posType=='SI'">
                        <li class="checkout-order-summary-list-items  ">
                            <div class="thumb product-list-item-img">
                                <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                    <cx-media
                                        [container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
                                </a>
                            </div>
                            <div class="checkout-EntryNumber">
                                {{entry?.updatedEntryNumber}}
                            </div>
                            <div class="details">
                                <div class="checkout-Entryitem-block  d-flex">
                                    <div class="col-xs-12 col-sm-5 col-md-6">
                                        <div>
                                            <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                                <strong class="name">{{entry?.product?.code}}</strong>
                                            </a>
                                            <span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
                                                {{entry?.product?.typenumber}}
                                            </span>
                                        </div>

                                        <div class="f-14">
                                            <br>
                                            {{entry?.product?.name}}
                                            <br>
                                        </div>
                                        <div class="f-14" *ngIf="entry?.customPartNumber">
                                            {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                        </div>
                                        <div class="checkout-Entryitem-qty">
                                        </div>
                                    </div>
                                    <div *ngIf="fleetPrideGroup"
                                        class="col-xs-12 col-sm-7 col-md-6 d-flex flex-column order-confirmation-price-block">
                                        <span class="checkout-netprice-block f-14" *ngIf="showNetPrice$|async">
                                            <span class="checkout-label-priceLabel ">
                                                {{'common.basket_page_customerPrice'|cxTranslate}}
                                            </span>
                                            <span class="checkout-input-price float-right">
                                                <strong
                                                    *ngIf="!entry?.basePrice.formattedValue || entry?.basePrice.formattedValue.indexOf('-') > -1; else netPrice">
                                                    {{'common.basket_page_poa'|cxTranslate}}
                                                </strong>
                                                <ng-template #netPrice>
                                                    <strong>
                                                        {{entry?.basePrice.formattedValue}}&nbsp;{{entry?.basePrice.currencyIso}}
                                                    </strong>
                                                </ng-template>
                                            </span>
                                        </span>
                                        <span class="checkout-netprice-block f-14 bl" *ngIf="showCorePrice$|async">
                                            <span
                                                class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
                                            <span class="checkout-input-price float-right">
                                                <strong
                                                    *ngIf="!entry?.surcharge?.formattedValue || entry?.surcharge?.formattedValue.indexOf('-') > -1; else corePrice">
                                                    {{'common.basket_page_poa'|cxTranslate}}
                                                </strong>
                                                <ng-template #corePrice>
                                                    <strong>
                                                        {{entry?.surcharge?.formattedValue}}&nbsp;{{entry?.surcharge?.currencyIso}}
                                                    </strong>
                                                </ng-template>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div class="checkout-required-block d-flex align-items-center f-14">
                                    <div class="del-quantity f-14">
                                        {{'common.basket_page_emea_orderQty'|cxTranslate}}:<span>
                                            {{entry?.quantity}}</span>
                                    </div>
                                    <div class="checkout-requiredDeliveryDate ">
                                        <span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
                                            : </span><span class="f-13">{{entry?.requestedDeliveryDate}}</span>
                                    </div>

                                    <ng-template #closeit></ng-template>
                                </div>
                                <div class="checkout-required-block d-flex align-items-center f-14">
                                    <div class="del-quantity f-14">
                                        {{'common.text_checkout_page_delivery_qty'|cxTranslate}}<span>
                                            {{entry?.estimatedQuantity}}</span>
                                    </div>

                                    <div class="checkout-estimateDeliveryDate "
                                        *ngIf="(activeStep == 4) && (entry?.updateable)">
                                        <span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
                                        <span class="f-14" *ngIf="!entry?.estimatedDeliveryDate"
                                            class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                        </span>
                                        <span class="f-14" *ngIf="entry?.estimatedDeliveryDate"
                                            class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
                                        </span>
                                    </div>
                                    <ng-template #closeit></ng-template>
                                </div>

                                <div class="checkout-required-block d-flex align-items-center f-14"
                                    *ngFor="let item of entry.associatedEntries">
                                    <div class="del-quantity f-14">
                                        {{'common.text_checkout_page_delivery_qty'|cxTranslate}}<span>
                                            {{item?.estimatedQuantity}}</span>
                                    </div>

                                    <div class="checkout-estimateDeliveryDate "
                                        *ngIf="(activeStep == 4) && (item?.updateable)">
                                        <span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
                                        <span class="f-14" *ngIf="!item?.estimatedDeliveryDate"
                                            class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                        </span>
                                        <span class="f-14" *ngIf="item?.estimatedDeliveryDate"
                                            class="checkout-estimate-empty">{{item?.estimatedDeliveryDate}}
                                        </span>
                                    </div>
                                    <ng-template #closeit></ng-template>
                                </div>
                            </div>

                        </li>
                    </ng-container>
                    <!-- Split end -->

                    <ng-container *ngIf="!entry.associatedEntries">
                        <li class="checkout-order-summary-list-items  ">
                            <div class="thumb product-list-item-img">
                                <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                    <cx-media
                                        [container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
                                </a>
                            </div>
                            <div class="checkout-EntryNumber">
                                {{entry?.updatedEntryNumber}}
                            </div>
                            <div class="details">
                                <div class="checkout-Entryitem-block  d-flex">
                                    <div class="col-xs-12 col-sm-5 col-md-6">
                                        <div>
                                            <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                                <strong class="name">{{entry?.product?.code}}</strong>
                                            </a>
                                            <span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
                                                {{entry?.product?.typenumber}}
                                            </span>
                                        </div>

                                        <div class="f-14">
                                            <br>
                                            {{entry?.product?.name}}
                                            <br>
                                        </div>
                                        <div class="f-14" *ngIf="entry?.customPartNumber">
                                            {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                        </div>
                                        <div class="checkout-Entryitem-qty">
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-7 col-md-6
                                       d-flex flex-column
                                          order-confirmation-price-block">
                                        <div *ngIf="fleetPrideGroup" class="d-flex flex-column">
                                            <span class="checkout-netprice-block f-14" *ngIf="showNetPrice$|async">
                                                <span class="checkout-label-priceLabel ">
                                                    {{'common.basket_page_customerPrice'|cxTranslate}}
                                                </span>
                                                <span class="checkout-input-price float-right">
                                                    <strong
                                                        *ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1; else netPrice">
                                                        {{'common.basket_page_poa'|cxTranslate}}
                                                    </strong>
                                                    <ng-template #netPrice>
                                                        <strong>
                                                            {{entry?.basePrice?.formattedValue}}&nbsp;{{entry?.basePrice?.currencyIso}}
                                                        </strong>
                                                    </ng-template>
                                                </span>
                                            </span>
                                            <span class="checkout-netprice-block f-14 bl" *ngIf="showCorePrice$|async">
                                                <span
                                                    class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
                                                <span class="checkout-input-price float-right">
                                                    <strong
                                                        *ngIf="!entry?.surcharge?.formattedValue || entry?.surcharge?.formattedValue.indexOf('-') > -1; else corePrice">
                                                        {{'common.basket_page_poa'|cxTranslate}}
                                                    </strong>
                                                    <ng-template #corePrice>
                                                        <strong>
                                                            {{entry?.surcharge?.formattedValue}}&nbsp;{{entry?.surcharge?.currencyIso}}
                                                        </strong>
                                                    </ng-template>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="checkout-required-block d-flex align-items-center f-14 ml line-item">
                                <div class="del-quantity f-14 pl">
                                    {{'common.product_detail_quantity'|cxTranslate}}:<span>
                                        {{entry?.formattedQuantity}}</span>
                                </div>
                                <div class="checkout-requiredDeliveryDate ">
                                    <span class="f-14"> {{'common.cart_page_reqdelivery'|cxTranslate}} : </span>
                                    <span class="f-14">{{entry?.requestedDeliveryDate}}</span>
                                </div>
                                <div class="checkout-estimateDeliveryDate "
                                    *ngIf="(activeStep == 4) && (entry?.updateable); else closeit">
                                    <span class="f-14"> {{'common.cart_page_estdelivery'|cxTranslate}} : </span>
                                    <span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                    </span>
                                    <span class="f-14" *ngIf="entry.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
                                    </span>
                                </div>
                                <ng-template #closeit></ng-template>
                            </div>
                        </li>
                    </ng-container>
                </div>
            </ul>

        </div>
    </div>
    <div *ngIf="subTotal && (activeStep !== 1||0)" class="account-orderdetail order-confirmation-orderdetails mb-3">
        <div class="account-orderdetail__footer">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 order-confirmation-priceBlock">
                    <div class="orderTotal order-confirmation-orderTotal">
                        <div class="row" *ngIf="showNetPrice$|async">
                            <div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label" *ngIf="fleetPrideGroup">
                                {{'common.order_totals_subtotal'|cxTranslate}}</div>
                            <div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit" *ngIf="fleetPrideGroup">

                                <div class="text-right"
                                    *ngIf="(total?.formattedValue.indexOf('-') < 0)
                                 &&(minOrderCharge?.formattedValue.indexOf('-') < 0) &&(subTotal?.formattedValue.indexOf('-') < 0);else nosubtotalPrice ">
                                    {{subTotal?.formattedValue}}&nbsp;{{subTotal?.currencyIso}}</div>
                                <ng-template #nosubtotalPrice>
                                    <div class="text-right">{{'common.basket_page_poa'|cxTranslate}}</div>
                                </ng-template>
                            </div>
                            <div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label"
                                *ngIf="minOrderCharge?.value??0 >0">
                                <div>
                                    {{'common.text_account_order_min_NA'|cxTranslate}}</div>
                            </div>
                            <div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit"
                                *ngIf="minOrderCharge?.value??0 >0">

                                <div class="text-right"
                                    *ngIf="(total?.formattedValue.indexOf('-') < 0)
                                 &&(minOrderCharge?.formattedValue.indexOf('-') < 0) &&(subTotal?.formattedValue.indexOf('-') < 0);else nominOrderSubChargePrice ">
                                    {{minOrderCharge?.formattedValue}}&nbsp;{{minOrderCharge?.currencyIso}}
                                </div>
                                <ng-template #nominOrderSubChargePrice>
                                    <div class="text-right">{{'common.basket_page_poa'|cxTranslate}}</div>
                                </ng-template>
                            </div>

                            <div class="col-xs-12 col-sm-12 row border-top my-2"></div>
                            <div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label-Total">
                                <div class="totals" *ngIf="fleetPrideGroup">
                                    {{'common.basket_page_totals_total'|cxTranslate}}</div>
                            </div>
                            <div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit-Total">

                                <div class="text-right totals"
                                    *ngIf="(total?.formattedValue.indexOf('-') < 0)
                                 &&(minOrderCharge?.formattedValue.indexOf('-') < 0) &&(subTotal?.formattedValue.indexOf('-') < 0);else noPrice ">
                                    {{total?.formattedValue}}&nbsp;{{total?.currencyIso}}</div>
                                <ng-template #noPrice>
                                    <div class="text-right totals">{{'common.basket_page_poa'|cxTranslate}}</div>
                                </ng-template>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="false" class="float-right col-xs-12 col-sm-6 col-md-5 col-lg-4 my-3">
        <div class="float-right">
            <button class="btn button-launch">
                Continue Shopping</button>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="isMobile">
    <ul class=" order-conformation-summary-list mobile-panel">
        <div class="mainEntryGroup" *ngFor="let entry of orderSummary">
            <div class="checkout-order-summary-list-items">
                <!-- sales bomb start -->
                <ng-container *ngIf="entry.associatedEntries && entry.posType=='KH'">
                    <mat-expansion-panel hideToggle>
                        <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'190px'">
                            <mat-panel-title>
                                <li class="checkout-order-summary-list-items  ">
                                    <div class="thumb product-list-item-img order-summary-img">
                                        <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                            <cx-media
                                                [container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
                                        </a>
                                    </div>
                                    <div class="checkout-EntryNumber">
                                        {{entry?.updatedEntryNumber}}
                                    </div>
                                    <div class="details">
                                        <div class="checkout-Entryitem-block  d-flex">
                                            <div class="col-xs-12 col-sm-5 col-md-6">
                                                <div>
                                                    <a
                                                        [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                                        <strong class="name">{{entry?.product?.code}}</strong>
                                                    </a>
                                                    <span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
                                                        {{entry?.product?.typenumber}}
                                                    </span>
                                                </div>

                                                <div class="f-14">
                                                    <br>
                                                    {{entry?.product?.name}}
                                                    <br>
                                                </div>
                                                <div class="f-14" *ngIf="entry?.customPartNumber">
                                                    {{'common.text_cust_part_no'|cxTranslate}}:
                                                    {{entry?.customPartNumber}}
                                                </div>
                                                <div class="checkout-Entryitem-qty">
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-7 col-md-6
                                       d-flex flex-column
                                          order-confirmation-price-block">
                                                <div *ngIf="fleetPrideGroup">
                                                    <span class="checkout-listprice-block f-14 "
                                                        *ngIf="showListPrice$|async">
                                                        <span class="checkout-label-priceLabel ">
                                                            {{'common.basket_page_listprice'|cxTranslate}}:
                                                        </span>
                                                        <span class="checkout-input-price float-right">
                                                            <strong
                                                                *ngIf="!entry?.listPrice || entry?.listPrice.indexOf('-') > -1 ; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
                                                            <ng-template
                                                                #listPrice><strong>{{entry?.listPrice}}&nbsp;{{entry?.listPrice?.currencyIso}}</strong></ng-template>
                                                        </span>
                                                    </span>
                                                    <span class="checkout-netprice-block f-14"
                                                        *ngIf="showNetPrice$|async">
                                                        <span class="checkout-label-priceLabel ">
                                                            {{'common.basket_page_netprice'|cxTranslate}}:
                                                        </span>
                                                        <span class="checkout-input-price float-right">
                                                            <strong
                                                                *ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1; else netPrice">
                                                                {{'common.basket_page_poa'|cxTranslate}}
                                                            </strong>
                                                            <ng-template #netPrice>
                                                                <strong>
                                                                    {{entry?.basePrice?.formattedValue}}&nbsp;{{entry?.basePrice?.currencyIso}}
                                                                </strong>
                                                            </ng-template>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="checkout-required-block d-flex align-items-center f-14">
                                            <div class="del-quantity f-14">
                                                {{'common.basket_page_emea_orderQty'|cxTranslate}}:<span>
                                                    {{entry?.formattedQuantity}}</span>
                                            </div>
                                            <div class="checkout-requiredDeliveryDate ">
                                                <span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
                                                    : </span><span class="f-13">{{entry?.requestedDeliveryDate |
                                                    kbDateFormat}}</span>
                                            </div>
                                            <div class="checkout-estimateDeliveryDate "
                                                *ngIf="(activeStep == 4) && (entry?.updateable)">
                                                <span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}}
                                                    :</span>
                                                <span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
                                                    class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                                </span>
                                                <span class="f-14" *ngIf="entry.estimatedDeliveryDate"
                                                    class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
                                                </span>


                                            </div>
                                            <ng-template #closeit></ng-template>
                                        </div>
                                    </div>
                                </li>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <li class="checkout-order-summary-list-items" *ngFor="let item of entry.associatedEntries">

                            <div class="thumb product-list-item-img">
                                <a [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl">
                                    <cx-media
                                        [container]="item?.product?.images && item?.product?.images['PRIMARY'] || item?.product?.images"></cx-media>
                                </a>
                            </div>
                            <div class="checkout-EntryNumber">
                                {{item?.updatedEntryNumber}}
                            </div>
                            <div class="details">
                                <div class="checkout-Entryitem-block  d-flex">
                                    <div class="col-xs-12 col-sm-5 col-md-6">
                                        <div>
                                            <a [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl">
                                                <strong class="name">{{item?.product?.code}}</strong>
                                            </a>
                                        </div>
                                        <div class="f-14">
                                            <br>
                                            {{item?.product?.name}}
                                            <br>
                                        </div>
                                        <div class="f-14" *ngIf="entry?.customPartNumber">
                                            {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                        </div>
                                        <div class="checkout-Entryitem-qty">
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-7 col-md-6
                                   d-flex flex-column
                                      order-confirmation-price-block">

                                        <div *ngIf="fleetPrideGroup">
                                            <span class="checkout-netprice-block f-14" *ngIf="showCorePrice$|async">
                                                <span
                                                    class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
                                                <span class="checkout-input-price float-right">
                                                    <strong
                                                        *ngIf="!item?.surcharge?.formattedValue|| item?.surcharge?.formattedValue.indexOf('-') > -1 ; else corePrice">
                                                        {{'common.basket_page_poa'|cxTranslate}}
                                                    </strong>
                                                    <ng-template #corePrice>
                                                        <strong>
                                                            {{item?.surcharge?.formattedValue}}&nbsp;{{item?.surcharge?.currencyIso}}
                                                        </strong>
                                                    </ng-template>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="checkout-required-block d-flex align-items-center f-14 sales-bomb-body">
                                    <div class="del-quantity f-14">
                                        {{'common.text_checkout_page_delivery_qty'|cxTranslate}}<span>
                                            {{item?.formattedQuantity}}</span>
                                    </div>

                                    <ng-template #closeit></ng-template>
                                </div>
                            </div>
                        </li>
                    </mat-expansion-panel>
                </ng-container>
                <!-- sales bomb end -->

                <!-- Replaced By Start -->
                <ng-container *ngIf="entry.associatedEntries && entry.posType=='AH'">
                    <li class="checkout-order-summary-list-items replace-by-list">
                        <div class="replaced-by-top">
                            <div class="thumb product-list-item-img">
                                <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                    <cx-media
                                        [container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
                                </a>
                            </div>
                            <div class="checkout-EntryNumber">
                                {{entry?.updatedEntryNumber}}
                            </div>
                            <div class="details">
                                <div class="checkout-Entryitem-block  d-flex">
                                    <div class="col-xs-12 col-sm-5 col-md-6">
                                        <div>
                                            <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                                <strong class="name">{{entry?.product?.code}}</strong>
                                            </a>
                                            <span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
                                                {{entry?.product?.typenumber}}
                                            </span>
                                        </div>
                                        <div class="f-14 product-name">
                                            <p>{{entry?.product?.name}}</p>
                                        </div>
                                        <div class="f-14" *ngIf="entry?.customPartNumber">
                                            {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                        </div>
                                    </div>

                                </div>
                                <div class="checkout-required-block d-flex align-items-center f-14">
                                    <div class="del-quantity f-14">
                                        {{'common.text_checkout_page_delivery_qty'|cxTranslate}}<span>
                                            {{entry?.formattedQuantity}}</span>
                                    </div>
                                    <ng-template #closeit></ng-template>
                                </div>
                                <div class="replaced-by-text">
                                    {{'common.checkout_page_replaced'|cxTranslate}}
                                </div>
                            </div>
                        </div>
                        <ng-container *ngFor="let item of entry.associatedEntries">
                            <div class="thumb product-list-item-img">
                                <a [routerLink]="{  cxRoute: 'product',params:item?.product } | cxUrl">
                                    <cx-media
                                        [container]="item?.product?.images && (item?.product?.images['PRIMARY'] || item?.product?.images)"></cx-media>
                                </a>
                            </div>
                            <div class="checkout-EntryNumber">
                                {{item?.updatedEntryNumber}}
                            </div>
                            <div class="checkout-Entryitem-block d-flex replaced-by-entries">
                                <div class="col-xs-12 col-sm-5 col-md-6">
                                    <div>
                                        <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                            <strong class="name">{{item?.product?.code}}</strong>
                                        </a>
                                    </div>
                                    <div class="f-14">
                                        <br>
                                        {{item?.product?.name}}
                                        <br>
                                    </div>
                                    <div class="f-14" *ngIf="entry?.customPartNumber">
                                        {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                    </div>
                                    <div class="checkout-Entryitem-qty">
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-7 col-md-6
                       d-flex flex-column
                          order-confirmation-price-block">
                                    <div *ngIf="fleetPrideGroup">
                                        <span class="checkout-listprice-block f-14 " *ngIf="showListPrice$|async">
                                            <span class="checkout-label-priceLabel ">
                                                {{'common.basket_page_listprice'|cxTranslate}}:
                                            </span>
                                            <span class="checkout-input-price float-right">
                                                <strong
                                                    *ngIf="!item?.listPrice?.formattedValue || item?.listPrice?.formattedValue.indexOf('-') > -1; else listPrice">{{'common.basket_page_poa'|cxTranslate}}</strong>
                                                <ng-template
                                                    #listPrice><strong>{{item?.listPrice?.formattedValue}}&nbsp;{{item?.listPrice?.currencyIso}}</strong></ng-template>
                                            </span>
                                        </span>
                                        <span class="checkout-netprice-block f-14" *ngIf="showNetPrice$|async">
                                            <span class="checkout-label-priceLabel ">
                                                {{'common.basket_page_netprice'|cxTranslate}}:
                                            </span>
                                            <span class="checkout-input-price float-right">
                                                <strong
                                                    *ngIf="!item?.basePrice?.formattedValue || item?.basePrice?.formattedValue.indexOf('-') > -1; else netPrice">
                                                    {{'common.basket_page_poa'|cxTranslate}}
                                                </strong>
                                                <ng-template #netPrice>
                                                    <strong>
                                                        {{item?.basePrice?.formattedValue}}&nbsp;{{item?.basePrice?.currencyIso}}
                                                    </strong>
                                                </ng-template>
                                            </span>
                                        </span>
                                        <span class="checkout-netprice-block f-14 " *ngIf="showCorePrice$|async">
                                            <span
                                                class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}&nbsp;&nbsp;</span>
                                            <span class="checkout-input-price float-right">
                                                <strong
                                                    *ngIf="!item?.surcharge?.formattedValue || item?.surcharge?.formattedValue.indexOf('-') > -1; else corePrice">
                                                    {{'common.basket_page_poa'|cxTranslate}}
                                                </strong>
                                                <ng-template #corePrice>
                                                    <strong>
                                                        {{item?.surcharge?.formattedValue}}&nbsp;{{item?.surcharge?.currencyIso}}
                                                    </strong>
                                                </ng-template>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="checkout-required-block d-flex align-items-center f-14 replaced-by-bottom">
                                <div class="del-quantity f-14">
                                    {{'common.basket_page_emea_orderQty'|cxTranslate}}:<span>
                                        {{item?.estimatedQuantity}}</span>
                                </div>
                                <div class="checkout-requiredDeliveryDate ">
                                    <span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
                                        : </span><span class="f-13">{{item?.requestedDeliveryDate|kbDateFormat}}</span>
                                </div>
                                <div class="checkout-estimateDeliveryDate "
                                    *ngIf="(activeStep == 4) && (item?.updateable)">
                                    <span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
                                    <span class="f-14" *ngIf="!item.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                    </span>
                                    <span class="f-14" *ngIf="item.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{item?.estimatedDeliveryDate}}
                                    </span>

                                </div>
                                <ng-template #closeit></ng-template>
                            </div>
                        </ng-container>
                    </li>
                </ng-container>
                <!-- Replaced By end -->

                <!-- Split Start -->
                <ng-container *ngIf="entry.associatedEntries && entry.posType=='SI'">
                    <li class="checkout-order-summary-list-items  ">
                        <div class="thumb product-list-item-img">
                            <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                <cx-media
                                    [container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
                            </a>
                        </div>
                        <div class="checkout-EntryNumber">
                            {{entry?.updatedEntryNumber}}
                        </div>
                        <div class="details d-flex flex-column">
                            <div class="checkout-Entryitem-block  d-flex">
                                <div class="col-xs-12 col-sm-5 col-md-6">
                                    <div>
                                        <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                            <strong class="name">{{entry?.product?.code}}</strong>
                                        </a>
                                        <span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
                                            {{entry?.product?.typenumber}}
                                        </span>
                                    </div>

                                    <div class="f-14">
                                        <br>
                                        {{entry?.product?.name}}
                                        <br>
                                    </div>
                                    <div class="f-14" *ngIf="entry?.customPartNumber">
                                        {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                    </div>
                                    <div class="checkout-Entryitem-qty">
                                    </div>
                                </div>
                                <div *ngIf="fleetPrideGroup"
                                    class="col-xs-12 col-sm-7 col-md-6 d-flex flex-column order-confirmation-price-block">
                                    <span class="checkout-netprice-block f-14" *ngIf="showNetPrice$|async">
                                        <span class="checkout-label-priceLabel ">
                                            {{'common.basket_page_customerPrice'|cxTranslate}}
                                        </span>
                                        <span class="checkout-input-price float-right">
                                            <strong
                                                *ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1; else netPrice">
                                                {{'common.basket_page_poa'|cxTranslate}}
                                            </strong>
                                            <ng-template #netPrice>
                                                <strong>
                                                    {{entry?.basePrice?.formattedValue}}&nbsp;{{entry?.basePrice?.currencyIso}}
                                                </strong>
                                            </ng-template>
                                        </span>
                                    </span>
                                    <span class="checkout-netprice-block f-14 bl" *ngIf="showCorePrice$|async">
                                        <span
                                            class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
                                        <span class="checkout-input-price float-right">
                                            <strong
                                                *ngIf="!entry?.surcharge?.formattedValue || entry?.surcharge?.formattedValue.indexOf('-') > -1; else corePrice">
                                                {{'common.basket_page_poa'|cxTranslate}}
                                            </strong>
                                            <ng-template #corePrice>
                                                <strong>
                                                    {{entry?.surcharge?.formattedValue}}&nbsp;{{entry?.surcharge?.currencyIso}}
                                                </strong>
                                            </ng-template>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div class="checkout-required-block d-flex align-items-center f-14">
                                <div class="del-quantity f-14">
                                    {{'common.basket_page_emea_orderQty'|cxTranslate}}:<span>
                                        {{entry?.quantity}}</span>
                                </div>
                                <div class="checkout-requiredDeliveryDate ">
                                    <span class="f-13"> {{'common.cart_page_reqdelivery'|cxTranslate}}
                                        : </span><span class="f-13">{{entry?.requestedDeliveryDate}}</span>
                                </div>

                                <ng-template #closeit></ng-template>
                            </div>
                            <div class="checkout-required-block d-flex align-items-center f-14">
                                <div class="del-quantity f-14">
                                    {{'common.text_checkout_page_delivery_qty'|cxTranslate}}<span>
                                        {{entry?.estimatedQuantity}}</span>
                                </div>

                                <div class="checkout-estimateDeliveryDate "
                                    *ngIf="(activeStep == 4) && (entry?.updateable)">
                                    <span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
                                    <span class="f-14" *ngIf="!entry?.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                    </span>
                                    <span class="f-14" *ngIf="entry?.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
                                    </span>
                                </div>
                                <ng-template #closeit></ng-template>
                            </div>

                            <div class="checkout-required-block d-flex align-items-center f-14"
                                *ngFor="let item of entry.associatedEntries">
                                <div class="del-quantity f-14">
                                    {{'common.text_checkout_page_delivery_qty'|cxTranslate}}<span>
                                        {{item?.estimatedQuantity}}</span>
                                </div>

                                <div class="checkout-estimateDeliveryDate "
                                    *ngIf="(activeStep == 4) && (item?.updateable)">
                                    <span class="f-13"> {{'common.cart_page_estdelivery'|cxTranslate}} :</span>
                                    <span class="f-14" *ngIf="!item?.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                    </span>
                                    <span class="f-14" *ngIf="item?.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{item?.estimatedDeliveryDate}}
                                    </span>
                                </div>
                                <ng-template #closeit></ng-template>
                            </div>
                        </div>

                    </li>
                </ng-container>
                <!-- Split end -->

                <ng-container *ngIf="!entry.associatedEntries">
                    <li class="checkout-order-summary-list-items  ">
                        <div class="thumb product-list-item-img">
                            <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                <cx-media
                                    [container]="entry?.product?.images['PRIMARY'] || entry?.product?.images"></cx-media>
                            </a>
                        </div>
                        <div class="checkout-EntryNumber">
                            {{entry?.updatedEntryNumber}}
                        </div>
                        <div class="details d-flex flex-column">
                            <div class="checkout-Entryitem-block  d-flex">
                                <div class="col-xs-12 col-sm-5 col-md-6">
                                    <div>
                                        <a [routerLink]="{  cxRoute: 'product',params:entry?.product } | cxUrl">
                                            <strong class="name">{{entry?.product?.code}}</strong>
                                        </a>
                                        <span class="f-14 d-block" *ngIf="entry?.product?.typenumber">
                                            {{entry?.product?.typenumber}}
                                        </span>
                                    </div>

                                    <div class="f-14">
                                        <br>
                                        {{entry?.product?.name}}
                                        <br>
                                    </div>
                                    <div class="f-14" *ngIf="entry?.customPartNumber">
                                        {{'common.text_cust_part_no'|cxTranslate}}: {{entry?.customPartNumber}}
                                    </div>
                                    <div class="checkout-Entryitem-qty">
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-7 col-md-6
                               d-flex flex-column
                                  order-confirmation-price-block">
                                    <div *ngIf="fleetPrideGroup" class="d-flex flex-column">
                                        <span class="checkout-netprice-block f-14">
                                            <span class="checkout-label-priceLabel ">
                                                {{'common.basket_page_customerPrice'|cxTranslate}}
                                            </span>
                                            <span class="checkout-input-price float-right" *ngIf="showNetPrice$|async">
                                                <strong
                                                    *ngIf="!entry?.basePrice?.formattedValue || entry?.basePrice?.formattedValue.indexOf('-') > -1; else netPrice">
                                                    {{'common.basket_page_poa'|cxTranslate}}
                                                </strong>
                                                <ng-template #netPrice>
                                                    <strong>
                                                        {{entry?.basePrice?.formattedValue}}&nbsp;{{entry?.basePrice?.currencyIso}}
                                                    </strong>
                                                </ng-template>
                                            </span>
                                        </span>
                                        <span class="checkout-netprice-block f-14 bl" *ngIf="showCorePrice$|async">
                                            <span
                                                class="checkout-label-priceLabel">{{'common.basket_page_coredeposit'|cxTranslate}}:&nbsp;&nbsp;</span>
                                            <span class="checkout-input-price float-right">
                                                <strong
                                                    *ngIf="!entry?.surcharge?.formattedValue || entry?.surcharge?.formattedValue.indexOf('-') > -1; else corePrice">
                                                    {{'common.basket_page_poa'|cxTranslate}}
                                                </strong>
                                                <ng-template #corePrice>
                                                    <strong>
                                                        {{entry?.surcharge?.formattedValue}}&nbsp;{{entry?.surcharge?.currencyIso}}
                                                    </strong>
                                                </ng-template>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="checkout-required-block d-flex align-items-center f-14 ml">
                                <div class="del-quantity f-14 pl">
                                    {{'common.product_detail_quantity'|cxTranslate}}:<span>
                                        {{entry?.formattedQuantity}}</span>
                                </div>
                                <div class="checkout-requiredDeliveryDate ">
                                    <span class="f-14"> {{'common.cart_page_reqdelivery'|cxTranslate}} : </span>
                                    <span class="f-14">{{entry?.requestedDeliveryDate}}</span>
                                </div>
                                <div class="checkout-estimateDeliveryDate "
                                    *ngIf="(activeStep == 4) && (entry?.updateable); else closeit">
                                    <span class="f-14"> {{'common.cart_page_estdelivery'|cxTranslate}} : </span>
                                    <span class="f-14" *ngIf="!entry.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{'common.checkout_estimateDeliveryDate_empty'|cxTranslate}}
                                    </span>
                                    <span class="f-14" *ngIf="entry.estimatedDeliveryDate"
                                        class="checkout-estimate-empty">{{entry?.estimatedDeliveryDate}}
                                    </span>
                                </div>
                                <ng-template #closeit></ng-template>
                            </div>
                        </div>

                    </li>
                </ng-container>
            </div>
        </div>
    </ul>
    <div *ngIf="activeStep == 4" class="account-orderdetail order-confirmation-orderdetails mb-3">
        <div class="account-orderdetail__footer">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8">
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4">
                    <div class="orderTotal order-confirmation-orderTotal">
                        <div class="row" *ngIf="showNetPrice$|async">
                            <div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label" *ngIf="fleetPrideGroup">
                                {{'common.order_totals_subtotal'|cxTranslate}}</div>
                            <div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit" *ngIf="fleetPrideGroup">

                                <div class="text-right"
                                    *ngIf="(total?.formattedValue.indexOf('-') < 0)
                                 &&(minOrderCharge?.formattedValue.indexOf('-') < 0) &&(subTotal?.formattedValue.indexOf('-') < 0);else nosubtotalPrice ">
                                    {{subTotal?.formattedValue}}&nbsp;{{subTotal?.currencyIso}}</div>
                                <ng-template #nosubtotalPrice>
                                    <div class="text-right">{{'common.basket_page_poa'|cxTranslate}}</div>
                                </ng-template>
                            </div>
                            <div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label"
                                *ngIf="minOrderCharge?.value??0 >0">
                                <div>
                                    {{'common.text_account_order_min_NA'|cxTranslate}}</div>
                            </div>
                            <div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit"
                                *ngIf="minOrderCharge?.value??0 >0">
                                <div class="text-right"
                                    *ngIf="(total?.formattedValue.indexOf('-') < 0)
                                 &&(minOrderCharge?.formattedValue.indexOf('-') < 0) &&(subTotal?.formattedValue.indexOf('-') < 0);else nominOrderSubChargePrice ">
                                    {{minOrderCharge?.formattedValue}}&nbsp;{{minOrderCharge?.currencyIso}}
                                </div>
                                <ng-template #nominOrderSubChargePrice>
                                    <div class="text-right">{{'common.basket_page_poa'|cxTranslate}}</div>
                                </ng-template>
                            </div>

                            <div class="col-xs-12 col-sm-12 row border-top my-2"></div>
                            <div class="col-xs-7 col-sm-7 order-confirmation-orderTotal-label-Total">
                                <div class="totals" *ngIf="fleetPrideGroup">
                                    {{'common.basket_page_totals_total'|cxTranslate}}</div>
                            </div>
                            <div class="col-xs-5 col-sm-5 order-confirmation-subTotal-Unit-Total">

                                <div class="text-right totals" *ngIf="(total?.formattedValue.indexOf('-') < 0)
                                 &&(minOrderCharge?.formattedValue.indexOf('-') < 0) &&(subTotal?.formattedValue.indexOf('-') < 0)
                                    ;else nototalPrice ">
                                    {{total?.formattedValue}}&nbsp;{{total?.currencyIso}}</div>
                                <ng-template #nototalPrice>
                                    <div class="text-right totals">{{'common.basket_page_poa'|cxTranslate}}</div>
                                </ng-template>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="false" class="float-right col-xs-12 col-sm-12  my-3">
        <div class="float-right">
            <button class="btn button-launch">
                Continue Shopping</button>
        </div>
    </div>
</ng-container>